export const SIMPLY_FORM = "Simple Form";
export const WIZARD_FORM = "Wizard Form";
